<!-- spinner.component.html -->
@if(isLoading()){
  <div class="overlay">
    <div class="loading-indicator">
      <tds-spinner size="lg" variant="standard"></tds-spinner>
      <!-- 显示当前状态和消息 -->
      <div class="status-container">
        <p class="status-message">{{ displayMessage }}</p>
        <!-- <p class="status-type">{{ status() | titlecase }}</p> -->
      </div>
      
     <!-- 显示所有文件的上传进度 -->
      @if(progress().length > 0) {
        <div class="multi-progress-container">
          @for(fileProgress of progress(); track fileProgress.fileName) {
            <div class="file-progress">
              <p class="file-name">{{ fileProgress.fileName }}</p>
              <div class="progress-bar-container">
                <div class="progress-bar" [style.width]="fileProgress.progress + '%'">
              </div>
                <span class="progress-text">{{ fileProgress.progress }}%</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}